export default "__VITE_ASSET__HNCJQzvE__"